module.exports = "<div class=\"sv-skeleton-element\" data-bind=\"attr: { id: element.id }\">\r\n</div>";